import {isNil} from 'ramda';

import {Integer} from '../types/Integer';
import {foundationTheme} from './foundationTheme';

/**
 * Converts pixels to steps based on the foundation theme's space.step
 * @param pixels - Number of pixels to convert
 * @returns Number of steps as Integer, rounded down
 */
export function getStepsFromPixels(pixels?: number): Integer | undefined {
  if (isNil(pixels)) {
    return undefined;
  }
  if (pixels === 0) {
    return 0;
  }

  // Get base font size dynamically
  const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const remInPixels = pixels / baseFontSize;
  const steps = remInPixels / foundationTheme.space.step;

  return Math.floor(steps) as Integer;
}
